import asyncComponent from '../component/asyncComponent'

export default [
    {
        name: "merchant-payment-old",
        route: "/merchant-payment",
        component: asyncComponent(() => import('../pages/merchant-payment')),
    },
    // {
    //     name: "test-wxpay",
    //     route: "/test/wxpay",
    //     component: asyncComponent(() => import('../pages/test/wxpay')),
    // },
    // {
    //     name: "merchant",
    //     route: "/merchant",
    //     component: asyncComponent(() => import('../pages/merchant')),
    // },
    {
        name: "merchant-payment",
        route: "/merchant/payment",
        component: asyncComponent(() => import('../pages/merchant/payment')),
    },
    {
        name: "merchant-status",
        route: "/merchant/status",
        component: asyncComponent(() => import('../pages/merchant/status')),
    },
    {
        name: "merchant-entry",
        route: "/merchant/entry",
        component: asyncComponent(() => import('../pages/merchant/entry')),
    },
    {
        name: "merchant-receipt",
        route: "/merchant/receipt",
        component: asyncComponent(() => import('../pages/merchant/receipt')),
    },
    {
        name: "merchant-scratch",
        route: "/merchant/scratch",
        component: asyncComponent(() => import('../pages/merchant/scratch')),
    },
]